import gql from 'graphql-tag';
const SCHEDULED_ACTIVITY_FRAGMENT = gql `
  fragment IKeyboardingScheduledActivityFragment on IKeyboardingScheduledActivity {
    scheduledActivityId
    spotCheck
  }
`;
export default SCHEDULED_ACTIVITY_FRAGMENT;
